/** @module csi/table/ChartTypeGallery */
define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/gallery/Widget",
	"csi/heading/Renderer",
	"csi/html",
	"csi/reflection",
	"csi/store/Nodes",
	"csi/widget/FusionChartStore",
	"csi/xml"
], function(declare,csi,_,GalleryWidget,Renderer,html,reflection,Nodes,FusionChartStore,xml) {

	var CSS_ATTR = "_CSS";
	var ID_ATTR = "_ID";

	var _IconRenderer = declare(Renderer, {
		/**
		 * Render icon using class specified on node.
		 * @param {Context} ctx
		 * @param {Heading} h
		 * @param {DOMNode} refNode
		 */
		headingToHtml: function(ctx, h, refNode) {
			html.create('span', {"class": "csi-svg-icon-size40 " + ctx.getNode()[CSS_ATTR]}, refNode);
		}
	});

	return declare(GalleryWidget, {
		"class": "csi-basic-gallery",
		galleryImageWidth: 145,
		galleryTemplate: "Basic",
		sortSettings: [],

		/**
		 * Return chart id for given chart node.
		 * @param {Node} node
		 * @return {string}
		 */
		getChartTemplate: function(node) {
			return node[ID_ATTR];
		},

		/**
		 * Return node representing given chart id.
		 * @param {string} id - chart identifier
		 * @return {Node}
		 */
		getChartTemplateNode: function(id) {
			return _.findWhere(this.store.query(), csi.objectNew(ID_ATTR, id));
		},

		/**
		 * Assign store and add renderer for image.
		 */
		postMixInProperties: function() {
			this.inherited(arguments);
			this.defView.defsByKey.image.classRenderer = _IconRenderer;
			this.set("store", this._getStore());
		},

		/**
		 * Create store of common chart types.
		 */
		_getStore: function() {
			var cache = this.cacheView;
			var type = reflection.TYPE_IMAGE;
			var nodes = FusionChartStore.query().map(function(item) {
				var node = cache.createClientNode(null, type, item.name);
				node[ID_ATTR] = FusionChartStore.getIdentity(item);
				node[CSS_ATTR] = item.cssClass;
				return node;
			});

			return new Nodes({
	    		cachingStore: cache,
	    		data: nodes
			});
		}
	});
});
